import { Box, Tooltip, useMediaQuery } from '@mui/material';
import PropTypes from 'prop-types';
import info from 'assets/images/Info_Cards.svg';

export default function InfoTooltip({ tooltip, mobileContent, alt }) {
  const isSmall = useMediaQuery('(max-width:959px)');
  return (
    <>
      <Tooltip enterTouchDelay={0} title={tooltip} placement="top" arrow>
        <img
          alt={alt}
          src={info}
          style={{
            position: 'absolute',
            top: '14px',
            right: '-22px',
            width: '15px',
            height: '15px',
            cursor: 'pointer',
            display: isSmall ? 'none' : 'block',
          }}
        />
      </Tooltip>
      <Box sx={{ fontSize: 14, display: { xs: 'block', md: 'none' }, position: 'relative', top: -4 }}>
        {mobileContent}
      </Box>
    </>
  );
}

InfoTooltip.propTypes = {
  tooltip: PropTypes.node.isRequired,
  mobileContent: PropTypes.node.isRequired,
  alt: PropTypes.string.isRequired,
};
